import { PoiButton } from './poi-button';

export default PoiButton;
